import {
  EnvironmentOutlined,
  IdcardOutlined,
  MailOutlined,
  PhoneOutlined,
  SolutionOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Col, Form, Input, Modal, Row, Select, Space } from "antd";
import PropTypes from "prop-types";
import { useEffect } from "react";

const expertTypeOptions = [
  "EXPERT MÉDICAL",
  "EXPERT MÉCANIQUE",
  "EXPERT JUDICIAIRE",
  "INVESTIGATEUR",
  "MEDECIN CONSEIL",
];

const AddExpert = ({ open, loading, onCancel, onSubmit, expert }) => {
  const [form] = Form.useForm();
  const isEdit = Boolean(expert);

  useEffect(() => {
    if (open) {
      if (expert) {
        form.setFieldsValue({
          nom: expert?.nom || "",
          prenom: expert?.prenom || "",
          adresse: expert?.adresse || "",
          profession: expert?.profession || "",
          email: expert?.email || "",
          telephone: expert?.contact?.[0] || "",
        });
      } else {
        form.resetFields();
      }
    }
  }, [open, expert, form]);

  const handleFinish = (values) => {
    onSubmit?.(values);
  };

  return (
    <Modal
      open={open}
      title={
        <span style={{ color: "#242166" }}>
          <SolutionOutlined style={{ marginRight: 8 }} />
          {isEdit ? "Modifier un expert" : "Ajouter un expert"}
        </span>
      }
      onCancel={onCancel}
      footer={null}
      width={640}
      destroyOnClose
      centered
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={handleFinish}
        requiredMark="optional"
      >
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Nom"
              name="nom"
              rules={[{ required: true, message: "Veuillez renseigner le nom" }]}
            >
              <Input
                size="large"
                prefix={<UserOutlined />}
                placeholder="Nom de l'expert"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Prénom(s)"
              name="prenom"
              rules={[
                { required: true, message: "Veuillez renseigner les prénoms" },
              ]}
            >
              <Input
                size="large"
                prefix={<UserOutlined />}
                placeholder="Prénom(s) de l'expert"
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          label="Type d'expert"
          name="profession"
          rules={[
            { required: true, message: "Veuillez sélectionner le type d'expert" },
          ]}
        >
          <Select
            size="large"
            placeholder="Sélectionnez le type d'expert"
            suffixIcon={<IdcardOutlined />}
            options={expertTypeOptions.map((value) => ({ value, label: value }))}
            allowClear
            showSearch
          />
        </Form.Item>

        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Téléphone"
              name="telephone"
              rules={[
                {
                  required: true,
                  message: "Veuillez renseigner le numéro de téléphone",
                },
              ]}
            >
              <Input
                size="large"
                prefix={<PhoneOutlined />}
                placeholder="Numéro de téléphone"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[{ type: "email", message: "Adresse email invalide" }]}
            >
              <Input
                size="large"
                prefix={<MailOutlined />}
                placeholder="Adresse email"
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          label="Adresse"
          name="adresse"
          rules={[{ required: true, message: "Veuillez renseigner l'adresse" }]}
        >
          <Input
            size="large"
            prefix={<EnvironmentOutlined />}
            placeholder="Adresse de l'expert"
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <Space style={{ width: "100%", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Annuler</Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {isEdit ? "Mettre à jour" : "Enregistrer"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

AddExpert.propTypes = {
  open: PropTypes.bool,
  loading: PropTypes.bool,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  expert: PropTypes.object,
};

export default AddExpert;
